import { Loading, Stack, Typography } from '@ui-components/neo.tax';
import React from 'react';

/**
 * Shown for a few seconds before the browser is redirected to a user's single-tenant Neo.Tax
 * instance, so the redirect doesn't feel abrupt.
 */
export const DomainRedirectInterstitial = (): React.ReactElement => (
  <Stack direction="column" alignItems="center" gap={4} paddingY={6}>
    <Loading height={50} />
    <Typography as="span" fontSize="sm" fontWeight="medium">
      You are being redirected to your organization&apos;s Neo.Tax instance.
    </Typography>
  </Stack>
);
